<template>
  <div class="tweetList">
    <blockquote class="twitter-tweet" v-for="tweet in tweets" :key="tweet.id"><a :href="`https://twitter.com/${tweet.id}/status/${tweet.status_id}`"></a></blockquote>
  </div>
</template>

<script>
export default {
  name: 'tweet-list',
  data() {
    return {
      archives: [
        { id: 'mimiko_4053', status_id: '1105642827080327169' },
        { id: 'ebinonigiri2', status_id: '1105420867926781952' },
        { id: 'natyunatyu0625', status_id: '1105419211587772416' },
        { id: '141chi_0501', status_id: '1105440170717831170' },
        { id: 'EdoRussianblue', status_id: '1105623786907262976' },
        { id: 'yukinko1033', status_id: '1105479920522747905' },
        { id: 'it2_rino', status_id: '1105647957800435712' },
        { id: '1tetu221s', status_id: '1105674942446632960' },
        { id: 'seimeiking', status_id: '1105694679553597441' },
        { id: 'seimeiking', status_id: '1105666067781738496' },
        { id: 'ayaittechu', status_id: '1105642148509020160' },
        { id: 'Hmio_o', status_id: '1105422454774624258' },
        { id: 'miyukittetsu', status_id: '1105420661650944000' }
      ],
      tweets: []
    };
  },
  mounted() {
    [...Array(3)].forEach(() => {
      const index = Math.floor(Math.random() * this.archives.length);
      this.tweets.push(this.archives[index]);
      this.archives.splice(index, 1);
    });
  }
};
</script>

<style lang="scss">
twitter-widget {
  margin: 0 auto !important;
  &:nth-of-type(n + 2) {
    margin-top: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/TweetList.vue